var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn-my-account  p-2 text-2xl inline cursor-pointer",on:{"click":function($event){return _vm.toggleMyAccount()}}},[_vm._v(" my account ")])}
var staticRenderFns = []

export { render, staticRenderFns }